import { OrganizationDto } from './organization-dto';

export class ChangeCandidateDto {
    importCandidateId = -1;
    exportingOrganization!: OrganizationDto;
    description?: string;
    hasNotification: boolean = false;
}
